<template>
  <div
    class="tw-w-full tw-flex tw-flex-col tw-items-center tw-text-center tw-text-xs"
  >
    <span>
      <i18n-t keypath="login_disclaimer">
        <template #game>
          {{ game.name }}
        </template>
      </i18n-t>
      <i18n-t keypath="terms_disclaimer">
        <template #studioterms>
          <i18n-t
            v-if="!!Settings.companyName && Settings.agreementUrls.length > 0"
            keypath="terms_disclaimer_studio"
          >
            <template #terms>
              <template
                v-for="({ name, url }, index) in Settings.agreementUrls"
                :key="index"
              >
                <a class="mod-link" :href="url" target="_blank">
                  {{ name }}
                </a>
                <span
                  v-if="
                    index + 1 < Settings.agreementUrls.length &&
                    index + 2 !== Settings.agreementUrls.length
                  "
                >
                  {{ $t('terms_disclaimer_studio_separator') }}
                </span>
                <span v-if="index + 2 === Settings.agreementUrls.length">
                  {{ $t('terms_disclaimer_studio_and') }}
                </span>
              </template>
            </template>
            <template #studio>{{ Settings.companyName }}</template>
          </i18n-t>
        </template>
        <template #terms>
          <a
            class="mod-link"
            href="https://mod.io/terms"
            @click.prevent="() => openModal(AGREEMENT_TYPE_TOU)"
            >{{ $t('terms') }}</a
          >
        </template>
        <template #privacy>
          <a
            class="mod-link"
            href="https://mod.io/privacy"
            @click.prevent="() => openModal(AGREEMENT_TYPE_PRIVACY)"
            >{{ $t('privacy') }}</a
          >
        </template>
        <template #min_age>
          {{ Settings.minAge }}
        </template>
      </i18n-t>
    </span>
  </div>
</template>

<script>
import { AGREEMENT_TYPE_PRIVACY, AGREEMENT_TYPE_TOU } from '@config/options.js'
import { MODAL_AGREEMENT } from '@config/globalModals.js'
import { setGlobalModal } from '@composables/useModal.js'
import { Settings } from '@config/game.js'
import { gameStore } from '@stores'
export default {
  setup() {
    const { getPublicGame } = gameStore()
    const game = getPublicGame()

    function openModal(type) {
      setGlobalModal({ modal: MODAL_AGREEMENT, data: { agreementType: type } })
    }

    return {
      AGREEMENT_TYPE_PRIVACY,
      AGREEMENT_TYPE_TOU,
      openModal,
      Settings,
      game,
    }
  },
}
</script>
